export default __webpack_public_path__ + "static/media/select-grouping.dc046736.svg";